export type MemberWorkspace = {
  id: number;
  name: string;
  description?: string;
};

const STORAGE_KEY = 'workspace_id_list';
const LEGACY_STORAGE_KEY = 'member_workspace_list';

function safeParse<T>(raw: string | null): T | null {
  if (!raw) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

/** 缓存 /app/member/info 返回的 workspaceIdList */
export function saveWorkspaceIdList(list: MemberWorkspace[]) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
}

export function loadWorkspaceIdList(): MemberWorkspace[] {
  if (typeof window === 'undefined') return [];
  const current = safeParse<MemberWorkspace[]>(window.localStorage.getItem(STORAGE_KEY));
  if (current?.length) return current;
  return safeParse<MemberWorkspace[]>(window.localStorage.getItem(LEGACY_STORAGE_KEY)) ?? [];
}

export function clearMemberWorkspaceCache() {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(STORAGE_KEY);
  window.localStorage.removeItem(LEGACY_STORAGE_KEY);
}

/** 默认工作空间：workspaceIdList 第一项的 id */
export function getDefaultWorkspaceId(): number | undefined {
  const id = loadWorkspaceIdList()[0]?.id;
  return typeof id === 'number' && id > 0 ? id : undefined;
}

/** @deprecated 使用 saveWorkspaceIdList */
export const saveMemberWorkspaceList = saveWorkspaceIdList;

/** @deprecated 使用 loadWorkspaceIdList */
export const loadMemberWorkspaceList = loadWorkspaceIdList;
